<template>
  <div class="card-working-hours">
    <div class="container-hours">
      <v-icon color="#123680" :size="iconSize">{{'equalizer'}}</v-icon>
      <div class="info-hours">
        <div v-if="loading">
          <img class="loader" :src="`${basePath}images/loader.gif`" width="60px" />
        </div>
        <span v-else class="hours" :style="'font-size: ' + hoursSize">{{this.items}}</span>
        <span class="text" :style="'font-size: ' + textSize">Performance</span>
      </div>
      <v-tooltip top style="padding-bottom: 50px">
        <v-icon slot="activator" color="black">{{'info'}}</v-icon>
        <span>Mostrar a porcentagem de tarefas concluídas que foram previstas para o período selecionado</span>
      </v-tooltip>
    </div>
  </div>
</template>

<style scoped>
  .card-working-hours{
    background: linear-gradient(to bottom right, #111769, #1AB5E0);
    padding: 4px;
    /* max-width: 300px; */
    width: 100%;
  }

  .card-working-hours .container-hours{
    background: #FFF;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 10px 0;
  }

  .card-working-hours .container-hours .info-hours{
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .card-working-hours .container-hours .info-hours span.hours{
    /* font-size: 1.8em; */
    font-weight: bold;
  }

  .card-working-hours .container-hours .info-hours span.text{
    /* font-size: 1.2em; */
    color: #000;
  }

</style>

<script>
  export default {
    props: ['itemsProp', 'loading'],
    created () {
      this.items = this.itemsProp
    },
    watch: {
      itemsProp () {
        this.items = this.itemsProp
      }
    },
    data: () => ({
      basePath: process.env.API,
      items: ''
    }),
    computed: {
      iconSize () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl':
            return '6.5em'
          default:
            return '5em'
        }
      },
      hoursSize () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl':
            return '3em'
          default:
            return '1.8em'
        }
      },
      textSize () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl':
            return '1.7em'
          default:
            return '1.2em'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/cards/CardDayPerformance.vue